import React, { Component } from "react";
import { Row } from "simple-flexbox";
import SidebarComponent from "../sidebar/SidebarComponent";
import HeaderComponent from "../header/HeaderComponent";
import { StyleSheet, css } from "aphrodite";

const SIDEBAR_WIDTH = 220;
const MOBILE_BREAKPOINT = 768;

class Layout extends Component {
  state = {
    selectedItem: "",
    windowWidth: window.innerWidth,
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  handleSidebarChange = (selectedItem) => {
    this.setState({ selectedItem });
  };

  render() {
    const { selectedItem, windowWidth } = this.state;
    const { children } = this.props;
    const isMobile = windowWidth <= MOBILE_BREAKPOINT;
    const isCompact =
      windowWidth <= 1366 && windowWidth > MOBILE_BREAKPOINT;

    return (
      <Row
        horizontal="center"
        style={{
          width: "100%",
          backgroundColor: "#f8f9fb",
        }}
      >
        <div
          className={css(
            styles.container,
            isCompact && styles.containerCompact
          )}
        >
          <div className={css(styles.sidebarSlot)}>
            <SidebarComponent
              selectedItem={selectedItem}
              onChange={this.handleSidebarChange}
            />
          </div>
          <div
            className={css(
              styles.mainBlock,
              isCompact && styles.mainBlockCompact
            )}
            style={{
              width: isMobile
                ? "100%"
                : `calc(100% - ${SIDEBAR_WIDTH}px)`,
            }}
          >
            <HeaderComponent title={selectedItem} key={1} />
            <div className={css(styles.content)}>{children}</div>
          </div>
        </div>
      </Row>
    );
  }
}

export default Layout;

const styles = StyleSheet.create({
  container: {
    height: "100%",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    maxWidth: 1600,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "12px 0 40px -15px #ddd, -12px 0 30px -15px #0B7535",
    overflow: "hidden",
  },
  containerCompact: {
    maxWidth: "100%",
  },
  sidebarSlot: {
    width: SIDEBAR_WIDTH,
    minWidth: SIDEBAR_WIDTH,
    maxWidth: SIDEBAR_WIDTH,
    flexShrink: 0,
    zIndex: 2,
    "@media (max-width: 768px)": {
      width: 0,
      minWidth: 0,
      maxWidth: 0,
    },
  },
  content: {
    marginTop: 100,
    width: "100%",
    position: "relative",
    zIndex: 1,
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      marginTop: 20,
    },
  },
  mainBlock: {
    backgroundColor: "#F7F8FC",
    padding: 30,
    minWidth: 0,
    flex: 1,
    position: "relative",
    zIndex: 1,
    overflowX: "hidden",
    overflowY: "visible",
    "@media (max-width: 768px)": {
      padding: 12,
    },
  },
  mainBlockCompact: {
    padding: 16,
  },
});
